import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { actionModalMessages } from "../../../orchestrator.messages";
import { SegmentEntity } from "../../../segment/domain/segment.entity";

interface SegmentInputProps {
  value: string;
  segments: SegmentEntity[];
  loading: boolean;
  onChange: (value: string) => void;
}

export function SegmentInput({ value, segments, loading, onChange }: SegmentInputProps) {
  const intl = useIntl();

  if (loading) {
    return (
      <div className="text-gray-500">
        <FormattedMessage {...actionModalMessages.loadingSegments} />
      </div>
    );
  }

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full border rounded px-3 py-2">
      {segments.length === 0 && (
        <option value="">{intl.formatMessage(actionModalMessages.noSegmentsAvailable)}</option>
      )}
      {segments.map(segment => (
        <option key={segment.ticker} value={segment.ticker}>
          {segment.name}
        </option>
      ))}
    </select>
  );
}
